import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Result
      status="404"
      title="404"
      subTitle={
        <span>
          抱歉，访问的页面不存在：<code style={{ background: '#f5f5f5', padding: '2px 6px', borderRadius: 4 }}>{location.pathname}</code>
        </span>
      }
      extra={
        <>
          <Button type="primary" onClick={() => navigate('/')} style={{ marginRight: 8 }}>
            返回首页
          </Button>
          <Button onClick={() => navigate(-1)}>返回上一页</Button>
        </>
      }
      style={{ paddingTop: 80 }}
    />
  );
}
